import { useState } from "react";

const useMessageReport = () => {
  const [loading, setLoading] = useState(false); //eslint-disable-line
  const [provinces, setProvinces] = useState([]); //eslint-disable-line
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [cities, setCities] = useState([]); //eslint-disable-line
  const [selectedCity, setSelectedCity] = useState(null);
  const [cars, setCars] = useState([]); //eslint-disable-line
  const [selectedCar, setSelectedCar] = useState(null);
  const [users, setUsers] = useState([]); //eslint-disable-line
  const [selectedUser, setSelectedUser] = useState(null);
  const [drivers, setDrivers] = useState([]); //eslint-disable-line
  const [selectedDriver, setSelectedDriver] = useState(null);

  return {
    loading,
    provinces,
    selectedProvince,
    setSelectedProvince,
    cities,
    selectedCity,
    setSelectedCity,
    cars,
    selectedCar,
    setSelectedCar,
    drivers,
    selectedDriver,
    setSelectedDriver,
    users,
    selectedUser,
    setSelectedUser,
  };
};

export default useMessageReport;
